import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import Courses from "./routes/Courses";
import Units from "./routes/Units";

export default store => ({
  path: "manage",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "manage-insights" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [Courses(store), Units(store)],
});
